import { url } from '@/config';
import request from '../axios'


export const getAllData = () => request({
  url: url + '/table/getAll',
  method: 'post',
});

export const uploadData = (data) => request({
  url: url + '/dataCenter/uploadData',
  method: 'post',
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  data
});

